import Login from "../../components/login/Login.vue"

export default {
    components: { Login },

    data: () => ({
        customItemsLogin: {},
        loading: false
    }),

    async created() {
        window.scrollTo(0,0);
        this.loading = !this.loading
        this.customItemsLogin = this.DATACUSTOM.text
        this.loading = !this.loading
    }
}